import styled from '@emotion/styled'
import ReactSelect from 'react-select'

const StyledReactSelect = styled(ReactSelect)`
    width: 100%;

    .Select__control {
		height: 3rem;
		width: 100%;
		padding: 0 1.5rem;

      border: 1px solid ${props => props.theme.colors.borderGray};
      border-radius: 12px;
      
		box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.25);
		-webkit-box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.25);
		-moz-box-shadow: 0 0 31px -3px rgba(179, 179, 179, 0.25);
		
		display: flex;
		flex-direction: row-reverse;
    }

    .Select__control--is-focused {
        outline: none;
        border-color: ${props => props.theme.colors.primary}; !important;
        border-width: 2px;
        box-shadow: none;
    }

    .Select__indicators {
        display: flex;
        flex-direction: row-reverse;
    }
`

export default StyledReactSelect
